export default __webpack_public_path__ + "assets/filters.80fc6d02.svg";